module.exports = __webpack_public_path__ + "Icono_Complemento-Bco_126px.png";